module.exports = __webpack_public_path__ + "img/heading_no.cccae725.svg";